/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PaymentModes,
  PaymentModeState
} from '@/store/interfaces/paymentMode';
import { RootState } from '@/store/interfaces/rootState';
import paymentModeType from '@/store/types/paymentMode';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): PaymentModeState => {
  return {
    paymentModesList: [],
  };
};

const state: PaymentModeState = initialState();

const getters: GetterTree<PaymentModeState, RootState> = {
  [paymentModeType.getters.GET_PAYMENT_MODES_LIST]: state => {
    return state.paymentModesList;
  },
};

const mutations: MutationTree<PaymentModeState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [paymentModeType.mutations.SET_PAYMENT_MODES_LIST]: (
    state,
    states: Array<PaymentModes>
  ) => {
    const paymentModes: Array<PaymentModes> = states;

    state.paymentModesList = paymentModes;
  },
};

const actions: ActionTree<PaymentModeState, RootState> = {
  [paymentModeType.actions.PAYMENT_MODES_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/payment-modes')
        .then((res: AxiosResponse) => {
          commit(
            paymentModeType.mutations.SET_PAYMENT_MODES_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
